import { createBrowserRouter } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Draft } from './pages/Draft';
import { Guess } from './pages/Guess';
import { Page404 } from './pages/Page404';
import { Home } from './pages/Home';
import { List } from './pages/List';
import { Logs } from './pages/Logs';
import { Contact } from './pages/Contact';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '',
        element: <Home />,
      },
      {
        path: 'draft/list',
        element: <List />,
      },
      {
        path: 'draft/logs',
        element: <Logs />,
      },
      {
        path: 'draft/create',
        element: <Draft />,
      },
      {
        path: 'draft/guess/:token',
        element: <Guess />,
      },
      {
        path: 'contact',
        element: <Contact />,
      },
      { path: '/404', element: <Page404 /> },
      { path: '*', element: <Page404 /> },
    ],
  },
]);
